export default __webpack_public_path__ + "static/media/Group411.292e6094.png";